module.exports = __webpack_public_path__ + "static/img/yingye.8754df41.png";